import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };
const base = `${API_BASE_URL}/Purchase`;

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the item category master list (page-load fetch)
export const getItemCategoryDetails = async () => {
    try {
        const res = await axios.get(`${base}/GetitemcategoryDetails`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the item category master list — used to refresh the dropdown after adding a new category
export const getItemCategoryDetailsFill = async () => {
    try {
        const res = await axios.get(`${base}/GetitemcategoryDetailsfill`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET DCAs configured for a category
export const getDcas = async (Id) => {
    try {
        const res = await axios.get(`${base}/GetDcas`, { params: { Id }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET Sub DCAs configured for a DCA
export const getSDcas = async (Id) => {
    try {
        const res = await axios.get(`${base}/GetSDcas`, { params: { Id }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET HSN codes configured for a category
export const getHsn = async (Id) => {
    try {
        const res = await axios.get(`${base}/GetHsn`, { params: { Id }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the HSN remarks text for a selected HSN id
export const getHsnDesc = async (Id) => {
    try {
        const res = await axios.get(`${base}/HsnDesc`, { params: { Id }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET major groups filtered for a category — Val: category id, Txt: category name
export const getMajougroupcode = async (Val, Txt) => {
    try {
        const res = await axios.get(`${base}/GetMajougroupcode`, { params: { Val, Txt }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the full major group master list — used to refresh the dropdown after adding a new one
export const getMajorgroupDetailsFill = async () => {
    try {
        const res = await axios.get(`${base}/Getmajorgroupdetailsfill`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET sub groups for a category + major group
export const getMajorsubgroups = async (Cat, Grp) => {
    try {
        const res = await axios.get(`${base}/GetMajorsubgroups`, { params: { Cat, Grp }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET existing specification codes for category + major group + sub group, used to
// auto-compute the next specification code
export const getSpecificationcode = async (Cat, MGrp, SGrp) => {
    try {
        const res = await axios.get(`${base}/GetSpecificationcode`, { params: { Cat, MGrp, SGrp }, headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the connected Sub-DCA list (shown only for category 2/3/4)
export const getConnectedSDcas = async () => {
    try {
        const res = await axios.get(`${base}/GetConectedSDcas`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET the units master list
export const getAllUnits = async () => {
    try {
        const res = await axios.get(`${base}/GetAllUnits`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — add a new item category
// payload: { ItemCategoryCode, ItemCategoryName }
export const saveItemCategory = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveItemCategory`, payload, { headers, timeout: 30000 });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — add a new major group under a category
// payload: { ItemCategoryCode, ItemCategoryName, Majorgroupcode, Majorgroupname }
export const saveMajorGroup = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveMajorGroup`, payload, { headers, timeout: 30000 });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — add a new unit
// payload: { Units }
export const saveUnits = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveUnits`, payload, { headers, timeout: 30000 });
        return res.data;
    } catch (err) { handle(err); }
};

// POST — final item code creation submit
export const saveItemCodeDetails = async (payload) => {
    try {
        const res = await axios.post(`${base}/SaveItemCodeDetails`, payload, { headers, timeout: 30000 });
        return res.data;
    } catch (err) { handle(err); }
};
